/**
 * @copyright Copyright 2020 Epic Systems Corporation
 * @file Self-triage context hook
 * @author <your full name>
 */

import { createContext, useContext } from "react";

import { ISelfTriage } from "../types";

export const __SelfTriageContext = createContext<ISelfTriage>({} as any);

export function useSelfTriage(): ISelfTriage {
	return useContext(__SelfTriageContext);
}
